export const getStringFromArguments = (...args: (string | null | undefined)[]) =>
  args.filter(el => !!el).join(', ');
